module.exports = __webpack_public_path__ + "img/logo_blue.c2df0318.png";